import { useIntl } from 'react-intl'

export const useOptionedString = () => {
    const { locale } = useIntl()

    return withOptions(locale)
}

const withOptions = locale => ({
    sv: string => `${string} …`
})[locale] ?? (string => `${string}…`)
